app.controller('previewExerciseBeginCtrl', [
    '$scope', '$interval', '$state', function ($scope, $interval, $state) {
        var vm = this;

        vm.setupExercise = function(exercise, questionIndex, fullFlow) {
            // Copied from gameService.js.
            function indexify(collection, forEachFunc) {
                for (var i = 0; i < collection.length; i++) {
                    var item = collection[i];
                    item.index = i;
                    if (forEachFunc) {
                        forEachFunc(item);
                    }
                }
            }

            indexify(exercise.evaluationQuestions, function(question) {
                indexify(question.answers);
            });

            vm.exercise = exercise;
            vm.questionIndex = questionIndex;
            vm.question = exercise.evaluationQuestions[questionIndex];
            vm.fullFlow = fullFlow;
        }

        vm.initialize = function() {
            if (!vm.fullFlow) {
                vm.progressIndex = 0;
                vm.progressCount = 1;
                vm.progressArray = new Array(vm.progressCount);
            } else {
                vm.progressIndex = 1 + vm.questionIndex;
                vm.progressCount = 1 + vm.exercise.questions.length + 1 + vm.exercise.evaluationQuestions.length + 1;
                vm.progressArray = new Array(vm.progressCount);
            }
        }

        var exerciseJson = window.localStorage.getItem("simulatorExercise");
        var exercise = JSON.parse(exerciseJson);
        var questionIndexStr = window.localStorage.getItem("simulatorExerciseEvalQuestionIndex");
        var questionIndex = parseInt(questionIndexStr, 10);
        var fullFlow = window.localStorage.getItem("simulatorFullFlow") == "true";
        vm.setupExercise(exercise, questionIndex, fullFlow);
        vm.initialize();

        vm.ebimageStyle = {
        	"background-image": "url(\"" + vm.exercise.imageUrl + "\")",
        	"background-size": "cover"
        };

        vm.next = function() {
            $state.go('preview.exerciseperform');
        }
    }
]);
